import { DamageSection } from '../types'

export default [
  {
    name: DamageSection.Zone,
    label: 'Zone',
    placeholder: 'Select Zone',
    options: [] as any,
    disabled: false,
    shouldResetOnChange: [DamageSection.Component, DamageSection.Fault],
    shouldFetchOnChange: [DamageSection.Component],
  },
  {
    name: DamageSection.Component,
    label: 'Component',
    placeholder: 'Select Component',
    options: [] as any,
    disabled: false,
    shouldResetOnChange: [DamageSection.Fault],
    shouldFetchOnChange: [DamageSection.Fault],
  },
  {
    name: DamageSection.Fault,
    label: 'Fault',
    placeholder: 'Select Fault',
    options: [] as any,
    disabled: false,
  },
]
